import { mountSearchspringBadges } from "../../snippets/ss-badges/mountSearchspringBadges";

const ROOT_SELECTOR = "[data-ss-recommendations-root]";
const CARD_SELECTOR = ".card-wrapper.product-card-wrapper";
const LINK_SELECTOR = 'a[href*="/products/"]';
const OVERLAY_SELECTOR = ".ss__overlay-badge";

function getHandleFromCard(card: HTMLElement): string {
  const href =
    card.querySelector<HTMLAnchorElement>(LINK_SELECTOR)?.getAttribute("href") ??
    "";
  if (!href) return "";
  const match = href.match(/\/products\/([^/?#]+)/);
  return match?.[1]?.trim() ?? "";
}

async function mountBadgesInRoot(root: HTMLElement): Promise<void> {
  const siteId = root.dataset.ssSiteId?.trim() ?? "";
  if (!siteId) return;

  const cards = root.querySelectorAll<HTMLElement>(CARD_SELECTOR);
  if (!cards.length) return;

  await mountSearchspringBadges({
    siteId,
    cards,
    getHandleFromCard,
    shouldSkipCard: (card) => Boolean(card.querySelector(OVERLAY_SELECTOR)),
  });
}

document.querySelectorAll<HTMLElement>(ROOT_SELECTOR).forEach((root) => {
  const mount = (): void => void mountBadgesInRoot(root);
  if (root.querySelector(CARD_SELECTOR)) return mount();

  const observer = new MutationObserver(() => {
    if (!root.querySelector(CARD_SELECTOR)) return;
    observer.disconnect();
    mount();
  });

  observer.observe(root, { childList: true, subtree: true });
});
